import React, { useEffect ,useState} from 'react';
import UseLangLstQuery from 'Apis/LangTxtInqApi';
import { useNavigate ,useLocation, Link,useOutletContext} from "react-router-dom";
import MgpStore from 'Stores/Store';
import 'Assets/css/cupn.css';
import GameCupnApi from 'Apis/GameCupnApi';
import { get } from 'http';

const GameRegistrationUi = () => {
    const location= useLocation(); 
    const serchParamsFunc = () => {
        return new URLSearchParams(location.search);
    }
    let query =serchParamsFunc();
    let getGameSvcCd = query.get("gameSvcCd")!;
    let OutletContextData = useOutletContext();
    const {isLoading,error,data: langData}:any = UseLangLstQuery();
    const [cupnCdState,setCupnCdState] = useState("");
    const [membUUIDState,setMembUUIDState] = useState<string|null>(null);
    const [gameMainPageInfoState,setGameMainPageInfoState] = useState<any>();
    const CupnCdHandler = (event:any) => {
        setCupnCdState(event.currentTarget.value);
    }
    const MembUUIDHandler = (event:any) => {
        setMembUUIDState(event.currentTarget.value);
    }
    // const CupnReqFunc = (cupnCd:string,MembUUID:string|null) => {
    //     GameCupnApi(getGameSvcCd,cupnCdState, membUUIDState,ReCaptchaToken).then((resp)=>{
    //         console.log(resp);   
    //     })
    // }

    useEffect(()=>{
        setGameMainPageInfoState(OutletContextData);
    },[MgpStore.getState().LangSetState.Lang, OutletContextData]);
    return(
        <div className='BgW'>
            <div className='RegiBgWrap'>
                <img src={process.env.PUBLIC_URL + '/images/pice/RegistrationBg.jpg'} alt="" />
                <div className='RegiOpacityBg'></div>
            </div>
            <div>
                <div>
                    <img src="" alt="" />
                    <ul>
                        <li>
                            <a href="#">
                                <img src="" alt="" />
                                앱스토어
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <img src="" alt="" />
                                구글 플레이
                            </a>
                        </li>
                    </ul>
                </div>
                <div>
                    <ul>
                        <li>
                            <a href="#">
                                컨텐츠1
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                컨텐츠2
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                컨텐츠3
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div>
                <div>
                    <h2>지금 사전 등록 이벤트에 참여해주세요</h2>
                    <img src="" alt="" />
                    <ul>
                        <li>
                            <a href="#"></a>
                        </li>
                        <li>
                            <a href="#"></a>
                        </li>
                    </ul>
                    <div>
                        <button>
                            <p>유의사항 확인하기</p>
                        </button>
                    </div>
                </div>
                <div>

                </div>
            </div>
            <div className='cupnInputBnrWrap'>
                <img src={gameMainPageInfoState&&gameMainPageInfoState.gameSvcUiInfo.subBnrUrl} alt="게임 서브 배너" />
                <div className='cupnInputWrap'>
                    <p>{gameMainPageInfoState&&gameMainPageInfoState.gameNm}{langData&&langData.GAME_CUPN_PAGE_TITL_00}</p>
                        {/*쿠폰*/}
                    <div>
                        { gameMainPageInfoState&&gameMainPageInfoState.gamePltf === "PC" ?
                        <input placeholder={`${langData&&langData.GAME_CUPN_MEMB_INPUT_DESC_00}`} type='text' className='cupnInput' autoComplete="off" onChange={MembUUIDHandler}></input>
                            //"회원 번호를 입력해주세요."
                        :
                        <></>
                        }
                        <input placeholder={`${langData&&langData.GAME_CUPN_CUPN_INPUT_DESC_00}`} type='text' className='cupnInput' autoComplete="off" onChange={CupnCdHandler}></input>
                        {/* 쿠폰 번호를 입력해주세요. */}
                    </div>
                    <div>
                        {/* <button onClick={() => CupnReqFunc(cupnCdState,membUUIDState)}>
                            <p>{langData&&langData.GAME_CUPN_MAIN_BTN_00}</p>
                        </button> */}
                    </div>
                </div>
            </div>
             { gameMainPageInfoState&&gameMainPageInfoState.gamePltf === "PC" ?
                <div>
                    <div>
                        <p>{langData&&langData.GAME_CUPN_MEMB_DESC_00}</p>
                        {/* <p>회원 정보 확인방법</p> */}
                    </div>
                    
                </div>
                :
                <></>
             }
            <div className='blckNoticeWrap'>
                <h3>{langData&&langData.GAME_CUPN_NOTI_DESC_00}</h3>
                <ul>
                    <li>
                        <p>유의사항1</p>
                    </li>
                    <li>
                        <p>유의사항2</p>
                    </li>
                    <li>
                        <p>유의사항3</p>
                    </li>
                    <li>
                        <p>유의사항4</p>
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default GameRegistrationUi;